<template>
    <div class="lotto-draw">
        <div class="lotto-draw__box">
            <div class="lotto-draw__list">
                <div class="lotto-draw__item">
                    <div
                        :class="['lotto-draw__item-checkbox', { active: dataSource.length === dataSelected.length }]"
                        @click="onSelectAllEvents()"
                    >
                        <label class="lotto-draw__item-checkbox__label">
                            {{ getTranslatedText('select all') }}
                        </label>
                    </div>
                </div>
                <div class="lotto-draw__item" v-for="(item, index) in dataSource" :key="index">
                    <div
                        :class="[
                            'lotto-draw__item-checkbox',
                            { active: dataSelected.some((draw) => draw.parent_id === item.parent_id) },
                        ]"
                        @click="onSelectItem(item)"
                    >
                        <label class="lotto-draw__item-checkbox__label">
                            {{ item.draw_name }}
                        </label>
                        <div class="lotto-draw__item-checkbox__content__info">
                            <div class="lotto-draw__item-checkbox__content__info-date">
                                <span v-if="checkCurrentToday(item.draw_date)">
                                    {{ renderDate(item.draw_date, true) }}
                                </span>
                                <span> {{ renderDate(item.draw_date) }}</span>
                            </div>
                            <div
                                :class="[
                                    'lotto-draw__item-checkbox__content__info-type',
                                    checkCurrentToday(item.draw_date) ? '' : item.type?.toLowerCase(),
                                ]"
                            >
                                {{ getTranslatedText(checkCurrentToday(item.draw_date) ? 'Tomorrow' : item.type) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="lotto-draw__box-button">
            <ButtonCommon
                type="default-3"
                value="Back"
                icon="arrow"
                className="lotto__events__box-button__back"
                @on-click-button-common="onGoBack"
            />
            <ButtonCommon
                :type="dataSelected?.length > 0 ? 'active' : 'default-3'"
                :isDisable="dataSelected?.length === 0"
                value="Continue"
                iconRight="arrow"
                className="lotto__events__box-button__continue"
                @on-click-button-common="onContinue"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { formatDateUTC, isCurrentToday } from '@/utils/utils';

import languageMixins from '@/mixins/language-mixins';
import ButtonCommon from '@/components/common/button/button.vue';

export default {
    mixins: [languageMixins],
    components: { ButtonCommon },
    props: {
        dataSource: {
            type: Array,
            default: () => [],
        },
        markets: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            dataSelected: [],
        };
    },
    computed: {
        ...mapState(['ModulesDailyLotto']),
    },
    methods: {
        onGoBack() {
            const query = this.$route.query;
            this.$router.push({ path: '/', query });
        },

        onContinue() {
            this.$store.dispatch('ModulesDailyLotto/actionSetDraws', this.dataSelected);
            this.$store.dispatch('ModulesDailyLotto/actionSetMarket', this.markets);
            
            const query = this.$route.query;
            this.$router.push({ path: '/lotto-fixed-daily-lotto/number', query });
        },

        // action select draws
        onSelectItem(v) {
            let dataSelected = [...this.dataSelected];
            const index = dataSelected.findIndex((item) => item.event_id === v.event_id);
            if (index !== -1) dataSelected.splice(index, 1);
            else
                dataSelected.push(v);

            this.dataSelected = dataSelected;
        },

        onSelectAllEvents() {
            if (this.dataSource.length === this.dataSelected.length) {
                this.dataSelected = [];
            } else {
                const dataSelectedClone = [...this.dataSelected];
                this.dataSource.forEach((item) => {
                    const index = dataSelectedClone.findIndex((v) => v.event_id === item.event_id);
                    if (index === -1)
                        dataSelectedClone.push(item);
                });

                this.dataSelected = dataSelectedClone;
            }
        },

        // common
        checkCurrentToday(date) {
            return !isCurrentToday(date);
        },

        renderDate(date, isShowDate = false) {
            const dateFormat = formatDateUTC(date);
            const { hour, minutes, day, year, month } = dateFormat;
            let valueDate = isShowDate ? `${day}/${month}/${year}` : `${hour}H${minutes}`;

            return valueDate;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/public/scss/loto/daily-lotto/events.scss';
</style>

